jQuery(function($) {
	'use strict';

	if ( ! $( document.body ).hasClass( 'post-type-archive-kalendarz' ) ) {
		return;
	}

	var $selector = $( '.calendar-month-selector' ),
		$months = $selector.find( 'a' );

	$months.on( 'click.delektujemy', function ( e ) {
		if ( $selector.hasClass( 'calendar-month-selector--open' ) && ! $( this ).hasClass( 'current' ) ) {
			return true;
		}

		e.preventDefault();

		$selector.toggleClass( 'calendar-month-selector--open' );
	});

	$( '.site-main article' ).find( '.entry-title' ).on( 'click', function ( e ) {
		e.preventDefault();

		$( this ).closest( 'article' ).toggleClass( 'open' );
	});
});
